import { useState, useEffect } from 'react'
import axios from 'axios'
import './UserList.css'
import MaterialTable from 'material-table'
import { $api } from '../../../helpers/api'

const UsersList = () => {
  // data for the table
  const [tableData, setTableData] = useState([])
  const [loading, setloading] = useState(false)

  // Table columns
  const columns = [
    { field: 'id', title: 'ID', editable: 'never' },
    { field: 'username', title: 'მომხმარებელი' },
    { field: 'userfullname', title: 'სახელი, გვარი' },
    { field: 'address', title: 'მისამართი' },
    { field: 'country', title: 'ქვეყანა' },
    { field: 'phonenumber', title: 'ტელ. ნომერი' },
    { field: 'birthdate', title: 'დაბადების თარიღი' },
    { field: 'email', title: 'ელ. ფოსტა' },
    {
      field: 'role',
      title: 'როლი',
      lookup: { admin: 'admin', user: 'user' },
    },
    { field: `createdAt`, title: 'რეგისტრაციის თარიღი', type: 'date', editable: 'never' },
  ]

  // User Data
  useEffect(() => {
    const getUsersList = async () => {
      try {
        setloading(true)
        const result = await $api.get(`/users`)
        setTableData(result?.data)
      } catch (e) {
        if (axios.isAxiosError(e)) {
          return console.error(e.message)
        }
      } finally {
        setloading(false)
      }
    }
    getUsersList()
  }, [])

  // Delete Users
  const deleteUser = async id => {
    await $api.delete(`/users/${id}`, {
      headers: { accessToken: localStorage.getItem('accessToken') },
    })
  }

  return (
    <>
      <div className='admin-user-list'>
        <div className='createInfoCard-container'>
          <div className='admin-information'>
            <div style={{ height: 760, width: '100%' }}>
              <MaterialTable
                title='მომხმარებლები'
                columns={columns}
                data={tableData}
                isLoading={loading}
                editable={{
                  onRowDelete: selectedRow =>
                    new Promise(resolve => {
                      const index = selectedRow.tableData.id
                      const updatedRows = [...tableData]
                      updatedRows.splice(index, 1)
                      deleteUser(selectedRow.id)
                      setTimeout(() => {
                        setTableData(updatedRows)
                        resolve()
                      }, 500)
                    }),
                  onRowUpdate: (newData, oldData) =>
                    new Promise(resolve => {
                      const updatedData = [...tableData]
                      updatedData[oldData.tableData.id] = newData
                      // Update Users
                      const updateRow = async id => {
                        await $api.put(
                          '/users/profileupdate',
                          {
                            id,
                            username: newData.username,
                            userfullname: newData.userfullname,
                            country: newData.country,
                            address: newData.address,
                            birthdate: newData.birthdate,
                            phonenumber: newData.phonenumber,
                            email: newData.email,
                            role: newData.role,
                          },
                          {
                            headers: { accessToken: localStorage.getItem('accessToken') },
                          }
                        )
                      }
                      updateRow(oldData.id)
                      setTimeout(() => {
                        setTableData(updatedData)
                        resolve()
                      }, 500)
                    }),
                }}
                options={{
                  actionsColumnIndex: -1,
                  addRowPosition: 'first',
                  exportButton: true,
                  columnsButton: true,
                  pageSizeOptions: [5, 10],
                  paginationType: 'stepped',
                  sorting: true,
                  filtering: true,
                  paging: true,
                  showFirstLastPageButtons: true,
                  paginationPosition: 'bottom',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UsersList
